import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import toastHandler from 'Utils/toastHandler';
import { STAGES_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IOrderStageRequest, IStage } from 'Data/interfaces/Obra/IObraStages';

export const useQueryOrderStages = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IOrderStageRequest) => {
      return ObrasApiV2.orderStages(variables);
    },
    onMutate: async (variables) => {
      const previousStages = queryClient.getQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionStieId],
      );

      queryClient.setQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionStieId],
        variables.stages,
      );

      return { previousStages };
    },
    onSuccess: async () => {
      toastHandler.showSuccess('Etapa ordenada com sucesso!');
    },
    onError: async (error: any, variables, context) => {
      await queryClient.cancelQueries({
        queryKey: [STAGES_QUERY_KEY, variables.constructionStieId],
      });

      queryClient.setQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionStieId],
        context?.previousStages,
      );

      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao ordenar Etapa!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    orderStage: mutate,
    isLoading: isPending,
  };
};
